import get from 'transmute/get';
export const getIndexedAsyncAssociations = get('associations');